import api from './index.js'

export const fetchApiConfigs = async (
  currentPage,
  pageSize,
  params,
  sortColumn,
  sortDirection
) => {
  try {
    const queryParams = new URLSearchParams(params).toString() // Convert params object to query string
    const response = await api.get(
      `/admin/api-config?pageNumber=${currentPage}&pageSize=${pageSize}&sortColumn=${sortColumn}&sortDirection=${sortDirection}&${queryParams}`
    )

    if (response.status === 200) {
      const data = response.data
      return data
    } else {
      throw new Error('Failed to fetch apiConfigs')
    }
  } catch (error) {
    throw new Error('Failed to fetch apiConfigs')
  }
}

export const fetchApiConfig = async id => {
  try {
    const response = await api.get(`/admin/api-config/${id}`)

    if (response.status === 200) {
      const data = response.data
      // Handle successful response
      // ...
      return data
    } else {
      throw new Error('Failed to fetch api config')
    }
  } catch (error) {
    // Handle error
    // ...
    throw new Error('Failed to fetch api config')
  }
}

export const updateApiConfig = async (id, apiData) => {
  try {
    const response = await api.put(`/admin/api-config/${id}`, apiData)

    if (response.status === 200) {
      const data = response.data
      // Handle successful response
      // ...
      return data
    } else {
      throw new Error('Failed to update api config')
    }
  } catch (error) {
    // Handle error
    // ...
    throw new Error('Failed to update api config')
  }
}
